const _NumberToHumanReadable = (
  input: number | null | undefined,
  floatingDigits: number = 2
): string => {
  if (input === null || input === undefined) return '-';
  if (Number.isNaN(Number(input))) return input.toString();
  const res = Number(Number(input).toFixed(floatingDigits)).toLocaleString(); //12345.6789 -> 12.345,67
  if (res.lastIndexOf(',') > -1 && res.length - res.lastIndexOf(',') <= floatingDigits)
    return res + '0'.repeat(res.length - 1 - res.lastIndexOf(',')); // 50,1 -> 50,10
  return res;
};

const _MathRound = (input: number) => (input + 0.5) << 0;
const _MathRoundUnsigned = (input: number) => (input < 0 ? (input - 0.5) << 0 : (input + 0.5) << 0);

export const FormatNumbers = {
  NumberToHumanReadable: _NumberToHumanReadable,
  MathRound: _MathRound,
  MathRoundUnsigned: _MathRoundUnsigned,
};
